/**
 * routerLinks contains the title, path and component name of each page.
 */
export const routerLinks = [{ title: 'Process cows', path: '/process', component: 'ProcessCows' }];
